import { useMemo } from 'react'

import {
   GetSearchAndMonitoringConfigResult,
   SearchAndMonitoringFieldConfig,
   SearchAndMonitoringFilterField
} from '@flowwai-frontend/bps-officer-web/graphql'
import { useApolloClientWithAuth } from '@flowwai-frontend/shared/auth/common'

import {
   GetSearchAndMonitoringConfigQuery as Query,
   GetSearchAndMonitoringConfigDocument as QueryDocument,
   GetSearchAndMonitoringConfigQueryVariables as QueryVariables
} from '../../apis/GetSearchAndMonitoringConfig/query.generatedTypes'

interface ReturnType {
   fields: SearchAndMonitoringFieldConfig[]
   filterFields: SearchAndMonitoringFilterField[]
   overviewFieldIds: string[]
}

const useGetSearchAndMonitoringConfigCache = (): ReturnType => {
   const client = useApolloClientWithAuth()

   const cacheData = useMemo((): GetSearchAndMonitoringConfigResult => {
      try {
         const cachedData = client.readQuery<Query, QueryVariables>({
            query: QueryDocument
         })

         switch (cachedData?.getSearchAndMonitoringConfig.__typename) {
            case 'GetSearchAndMonitoringConfigResult': {
               const config = cachedData.getSearchAndMonitoringConfig

               const fields = config.fields || []
               const filterFields = config.filterFields || []
               const overviewFieldIds = config.overviewFieldIds || []

               return {
                  fields,
                  filterFields,
                  overviewFieldIds
               } as GetSearchAndMonitoringConfigResult
            }

            case 'SearchAndMonitoringAccessControlConfigNotFound':
            default: {
               return {
                  fields: [],
                  filterFields: [],
                  overviewFieldIds: []
               } as GetSearchAndMonitoringConfigResult
            }
         }
      } catch (error) {
         return {
            fields: [],
            filterFields: [],
            overviewFieldIds: []
         }
      }
   }, [])

   return cacheData
}

export default useGetSearchAndMonitoringConfigCache
